import { actionsDisabled } from '../../utils/actionsDisabled';
import { DefaultColumns } from './data';
import { Divider } from '@mui/material';
import { fetchTendersByStatus, manuallyTenderShipments, releaseOrReTender } from '../../services/shipmentApi';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { GridColDef } from '@mui/x-data-grid-premium';
import { ManualTender } from '../../models/ManualTender';
import { ManualTenderModal } from '../../components/controls/modals/manualTenderModal';
import { RefreshButton } from '../../components/controls/buttons/refreshButton';
import { ReleaseOrRetenderModal } from '../../components/controls/modals/releaseOrRetenderModal';
import { ReleaseTenderButton } from '../../components/controls/buttons/releaseTenderButton';
import { removeOrAddColumn, reorderColumn } from '../../utils/columnReorder';
import { StandardBoard } from '../../components/standardBoard';
import { Tender } from '../../models/tender';
import { TenderShipmentButton } from '../../components/controls/buttons/tenderShipmentButton';
import { useAuth } from '../../auth';
import { columnDataFormatter } from '../../utils/columnDataFormatter';

export function TenderRejectedBoard() {
    const columnsStorageKey = 'tenderRejectedBoardColumns';
    useEffect(() => {
        if (localStorage.getItem(columnsStorageKey)) {
            let columnObj = localStorage.getItem(columnsStorageKey);
            let obj = columnObj && JSON.parse(columnObj);

            if (obj) {
                let formattedColumns = columnDataFormatter(obj);
                setColumns(formattedColumns);
            }
        }
    }, [])

    const auth = useAuth();

    const [isLoading, setIsLoading] = useState(true);
    const [tenders, setTenders] = useState<Tender[]>([]);
    const [selectedShipments, setSelectedShipments] = useState<number[]>([]);
    const [isColumnsDialogOpen, setColumnsOpen] = useState(false);
    const [manualTenderModalOpen, setManualTenderModalOpen] = useState(false);
    const [retenderModalOpen, setRetenderModalOpen] = useState(false);
    const [columns, setColumns] = useState<GridColDef[]>(DefaultColumns);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        const data = await fetchTendersByStatus('TenderRejected');
        setTenders(data);
        setIsLoading(false);
    }, []);

    const onColumnAddedRemoved = (column: any) => {
        let updatedColumns = removeOrAddColumn(columns, column, columnsStorageKey);
        setColumns(updatedColumns);
    }

    const onColumnIndexChange = (columnPropertyName: string, targetIndex: number) => {
        let updatedColumns = reorderColumn(columns, columnPropertyName, targetIndex, columnsStorageKey);
        setColumns(updatedColumns);
    }

    const retender = async () => {

        setRetenderModalOpen(false);

        setIsLoading(true);
        await releaseOrReTender(selectedShipments);
        await fetchData();
        setIsLoading(false);
    }

    const manualTenderShipments = async (comment: string) => {

        setManualTenderModalOpen(false);
        setIsLoading(true);

        let mt: ManualTender = {
            shipmentIDs: selectedShipments,
            comment: comment
        };

        await manuallyTenderShipments(mt);

        fetchData();
        setIsLoading(false);

    }

    useEffect(() => {
        fetchData()
            .catch(console.error);;
    }, [fetchData])

    function onColumnsDialogClose() {
        setColumnsOpen(false);
        setManualTenderModalOpen(false);
        setRetenderModalOpen(false);
    }

    const secondaryElement = (
        <Fragment>
            <TenderShipmentButton disabled={actionsDisabled(selectedShipments)} title='Manually tender the selected shipments.' onClick={() => setManualTenderModalOpen(true)} />
            <Divider style={{ margin: '5px' }} orientation='vertical' />
            <RefreshButton title='Refresh the current report list' onClick={() => fetchData()} />
        </Fragment>
    );

    return (
        <StandardBoard
            title='Rejected Tenders Board'
            primaryElement={<ReleaseTenderButton disabled={actionsDisabled(selectedShipments)} isRetender={true} title='Re-tender the selected shipments' onClick={() => setRetenderModalOpen(true)} />}
            secondaryElement={secondaryElement}
            gridProps={{
                filterStorageObject: 'rejectedBoardFilters',
                groupingStorageObject: 'rejectedBoardGrouping',
                setSelectedShipments: setSelectedShipments,
                tenders: tenders,
                onColumnIndexChange,
            }}
            columns={columns}
            isColumnsDialogOpen={isColumnsDialogOpen}
            onColumnsDialogChanged={onColumnAddedRemoved}
            onColumnsDialogClose={onColumnsDialogClose}
            isBackdropVisible={isLoading}
            onColumnButtonClick={() => setColumnsOpen(true)}
        >
            <ManualTenderModal open={manualTenderModalOpen} close={onColumnsDialogClose} confirmManualTender={manualTenderShipments} />
            <ReleaseOrRetenderModal retender={true} open={retenderModalOpen} close={onColumnsDialogClose} confirmReleaseOrTender={retender} />
        </StandardBoard>
    );
}